export default [
  {
    path: '/employee',
    name: 'list-operator',
    component: () => import('@/views/operator/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.employee',
      resource: 'manage-users',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listEmployee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/employee/create',
    name: 'create-operator',
    component: () => import('@/views/operator/Create.vue'),
    meta: {
      pageTitle: 'breadcrumb.employee',
      navActiveLink: 'list-operator',
      resource: 'manage-users',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.listEmployee',
          to: { name: 'list-operator' },
        },
        {
          text: 'breadcrumb.createEmployee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/employee/:id/update',
    name: 'update-operator',
    component: () => import('@/views/operator/Update.vue'),
    meta: {
      pageTitle: 'breadcrumb.employee',
      navActiveLink: 'list-operator',
      resource: 'manage-users',
      action: 'update',
      breadcrumb: [
        {
          text: 'breadcrumb.listEmployee',
          to: { name: 'list-operator' },
        },
        {
          text: 'breadcrumb.updateEmployee',
          active: true,
        },
      ],
    },
  },
  {
    path: '/employee/:id/details',
    name: 'details-operator',
    component: () => import('@/views/operator/Details.vue'),
    meta: {
      pageTitle: 'breadcrumb.employee',
      navActiveLink: 'list-operator',
      resource: 'manage-users',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listEmployee',
          to: { name: 'list-operator' },
        },
        {
          text: 'breadcrumb.detailsEmployee',
          active: true,
        },
      ],
    },
  },
]
